import React, { useEffect, useState } from 'react'
import ItemCardSucursal from '../Reportes/ItemCardSucursal';
import ConsultasComunes from '../Sql/ConsultasComunes';

function ItemEstadoSucursal(props) {
    const { sucursalinfo, actualizar } = props;
    const [error, setError] = useState(null);
    const [pedidos, setPedidos] = useState([]);
    const getInformacionPedidos = async () => {
        try {
            var resultado = await ConsultasComunes.getInformacionPedidos({ ...sucursalinfo });
            if (resultado.ok) {
                setError(null);
                if (sucursalinfo.ID_SUCURSAL == 5) { console.log(resultado.ok.pedidos); }
                setPedidos(resultado.ok.pedidos);
            } else {
                setError({ "error": resultado.error })
            }
        } catch (error) {
            console.log(error.message)
            setError({ "error": error.message })
        }
    }
    function getInformacion(valor){
        var mostrarr = ''
        if(valor.Alas!=0){
            mostrarr+=valor.Alas+'A'
        }
        if(valor.Piernas!=0){
            mostrarr+='+'+valor.Piernas+'P'
        }
        if(valor.Pipocas!=0){
            mostrarr+='+'+valor.Pipocas+'C'
        }
        return mostrarr
    }
    function getEstado(valor){
        if(valor.Estado=='T'){
            return 'TOMADO'
        }else if(valor.Estado=='A'){
            return 'PENDIENTE'
        }else if(valor.Estado=='L'){
            return 'LLAMADO'
        }else{
            return 'ESPERA'
        }
    }
    useEffect(() => {
        getInformacionPedidos()
    }, [actualizar])
    return (
        <div className='card bg-dark border border-light'>
            <div className='card-header text-light text-center fw-bold m-0 p-0'>
                {sucursalinfo.SUCURSAL}
            </div>
            <div className='card-body mx-1 p-0'>
                <div className='container-fluid overflow-auto' style={{height:'140px'}}>
                    {pedidos.map((item, index) => {
                        return (
                            <div className='row row-cols gx-1 bg-secondary mb-1 text-light'>
                                <div className='col my-auto' style={{fontSize:'10px', minWidth: '70px', maxWidth: '70px' }}>
                                    {item.Despacho}
                                </div>
                                <div className='col text-center my-auto'>
                                    <div>{item.PedidoNro}</div>
                                    <div style={{fontSize:'12px'}}>{item.Tipo == 'L' ? 'LLEVAR' : 'AQUI'}</div>
                                </div>
                                <div className='col text-center my-auto'>
                                    <div>{getInformacion(item)}</div>
                                </div>
                                <div className='col text-center my-auto'>
                                    <div style={{fontSize:'12px'}}>{getEstado(item)}</div>
                                </div>
                                <div className='col my-auto text-center' style={{ minWidth: '50px', maxWidth: '50px' }}>
                                    <div>{item.Tiempo.toFixed(0)} m</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='card-footer mx-1 p-0'>
                <ItemCardSucursal sucursal={sucursalinfo} actualizar={actualizar} vista={'L'} />
            </div>
        </div>
    )
}

export default ItemEstadoSucursal